import { cn } from '@plato/ui/util/classes';

type Props = {
    className?: string;
};

export function PersonIcon({ className = '' }: Props) {
    return (
        <svg
            className={cn('stroke-neutral-400', className)}
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="14"
            fill="none"
            viewBox="0 0 11 14"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.922 3.308a2.308 2.308 0 11-4.615 0 2.308 2.308 0 014.615 0zM1 11.996a4.615 4.615 0 019.23 0A11.036 11.036 0 015.614 13c-1.647 0-3.21-.36-4.615-1.004z"
            ></path>
        </svg>
    );
}
